var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.973c7.56 0 15.391-.213 22.682-1.09 4.324-.52 8.58-1.193 12.917-.726 4.528.489 9.24 0 13.826 0 8.244 0 16.448.934 24.712.934 8.613 0 16.592-.208 27.163-.208 6.756 0 11.81.416 18.412.416 4.013 0 8.934-1.203 12.916-.416 3.855.762 8.399.566 12.286 1.09 8.651 1.166 17.289.986 25.973.986 4.937 0 9.728-.62 14.667-.986 5.732-.425 11.475-.674 17.326-.674 6.698 0 13.106.036 19.777.674 13.947 1.334 22.438.986 41.024.986h39.939c4.285 0 6.686 0 12.042-.986 7.56-.674 7.682-.166 11.026-.674 7.629-1.16 15.633 0 23.312 0",
    stroke: "#5A2F56",
    strokeLinecap: "round"
  })));
}
export default SvgLine;